import React, { useEffect, useState } from 'react';
import { FlatList, View, ScrollView, TextInput, ActivityIndicator } from 'react-native';
import { Icon } from 'react-native-elements';
import Modal from 'modal-enhanced-react-native-web';
import { useDispatch, useSelector } from 'react-redux';
import Colors from '../../../constants/Colorsv2';
import Styles from '../../../constants/Styles';
import { PlayerTagProps, TagProps } from '../../../store/types/soc_svc';
import { social_getPlayerTagsByPlayerId, social_getTags } from '../../../store/actionsv1/social';
import { PublicPlayerProps } from '../../../store/types/auth_svc';
import { Text, TouchableOpacity } from '../../../globalComponents/NativeOverrides';
import PlayerTagLozenge from './PlayerTagLozenge';

type ScheduleOptionType = { type: 'immediate' | 'schedule', label:string }
const scheduleOptions:ScheduleOptionType[] = [{ type:'immediate', label:'Post Immediately' }, { type:'schedule', label: 'Schedule Post' }]

type PublishPostModalProps = { isVisible:boolean, closeModal:any, onAdd:(player_tags:PlayerTagProps[], featured?:boolean) => void }
function PublishPostModal ({isVisible, closeModal, onAdd }: PublishPostModalProps ){
    const [ loading, setLoading ] = useState(false);
    const [ featured, setFeatured ] = useState(false);
    const [ searchValue, setSearchValue ] = useState('');
    const [ selectedSchedule, setSelectedSchedule ] = useState(scheduleOptions[0]);
    const [ selectedTopics, setSelectedTopics ] = useState<TagProps[]>([]);
    const dispatch = useDispatch();
    const player:PublicPlayerProps | undefined = useSelector((state:any) => state.player.player, (left, right) => left?.player_id == right?.player_id)
    const company_tags:PlayerTagProps[] = useSelector((state:any) => state.social.player_tags.filter((pt:PlayerTagProps) => pt.tag_type === 'company'), (left, right) => left.length === right.length)
    const available_tags:TagProps[] = useSelector((state:any) => state.social.tags, (left, right) => left.length === right.length)
    const app_size = useSelector((state:any) => state.util.app_size, (left, right) => left.width === right.width)

    useEffect(() => {
        if(isVisible){ loadModalData() }
    },[isVisible])

    const loadModalData = async() => {
        if(!player){ return }
        setLoading(true)
        await dispatch(social_getPlayerTagsByPlayerId(player?.player_id, 0, true))
        await dispatch(social_getTags(0, 'selected'))
        setLoading(false)
    }

    const renderScheduleOptions = (data: { item: ScheduleOptionType, index:number }) => {
        const selected = selectedSchedule.type === data.item.type?true:false
        return (
            <TouchableOpacity style={{flexDirection:'row', alignItems:'center', marginTop:12}}>
                <View style={{ marginRight:12, height:24, width:24, borderRadius:100, borderWidth:1, borderColor:Colors.highlights.highlight200, justifyContent:'center', alignItems:'center' }}>
                    {selected?
                        <View style={{ height:14, width:14, borderRadius:100, backgroundColor:Colors.highlights.highlight200 }} />
                    :<></>}
                </View>
                <Text style={selected?Styles.textStyles.blueBoldLeft14:Styles.textStyles.grey300RegularLeft14}>{data.item.label}</Text>
                {data.item.type === 'schedule' ?
                <Text style={Styles.textStyles.grey300RegularLeft14}> Not Available</Text>
                :<></>}
            </TouchableOpacity>
        )
    }

    const handleSelectedTopic = (topic:TagProps) => {
        const selected = selectedTopics.find(t => t.tag_id === topic.tag_id)
        if(selected){ return setSelectedTopics(selectedTopics.filter(t => t.tag_id !== topic.tag_id)) } //Remove the topic
        return setSelectedTopics(selectedTopics.concat(topic))
    }

    const handleAddCompanyTopic = (playerTag:PlayerTagProps) => {
        const selected = selectedTopics.find(t => t.tag_id === playerTag.tag_id)
        if(selected){ return setSelectedTopics(selectedTopics.filter(t => t.tag_id !== playerTag.tag_id)) } //Remove the topic
        let topic:TagProps = { tag_id:playerTag.tag_id, tag_type:playerTag.tag_type, tag:playerTag.tag, company_id:playerTag.company_id, companyDetails:playerTag.companyDetails, create_datetime:'',status:'active' }
        return setSelectedTopics(selectedTopics.concat(topic))
    }

    const renderCompanyTopics = (data: {item:PlayerTagProps, index:number}) => {
        const selected = selectedTopics.find(t => t.tag_id === data.item.tag_id)?true:false
        return (
            <TouchableOpacity style={{flexDirection:'row', alignItems:'center', marginTop:12}} onPress={() => handleSelectedTopic(data.item)}>
                <View style={{height:24, width:24, borderWidth:1, borderRadius:4, borderColor:Colors.highlights.highlight200, justifyContent:'center', alignItems:'center', marginRight:5}}>
                    {selected?
                    <Icon name='check' type='feather' size={12} color={Colors.highlights.highlight200} />
                    :<></>}
                </View>
                <Text style={Styles.textStyles.blueRegularLeft14}>{data.item.tag}</Text>
            </TouchableOpacity>
        )
    }

    const renderAvailableTopics = (topic:TagProps) => {
        return (
            <View style={{marginRight:4, marginTop:8}} key={topic.tag_id.toString()}>
                <PlayerTagLozenge player_tag={topic} onSelect={(player_tag) => handleSelectedTopic(player_tag)}/>
            </View>
        )
    }

    const renderSelectedTopics = (topic:TagProps) => {
        return (
            <View style={{marginRight:4, marginTop:8}} key={topic.tag_id.toString()}>
                <PlayerTagLozenge selected player_tag={topic} onSelect={(player_tag) => handleSelectedTopic(player_tag)}/>
            </View>
        )
    }

    const availTopics = available_tags.filter(t => 
        t.tag.toLocaleLowerCase().startsWith(searchValue.toLocaleLowerCase())
    ).slice(0,20)

    return (
        <Modal isVisible={isVisible} coverScreen={true} style={{ flex:1, margin:0, justifyContent: 'flex-end', alignItems:'center'}} animationIn='slideInUp' animationOut='slideOutDown' animationOutTiming={400}
        onSwipeComplete={() => closeModal()} onBackdropPress={() => closeModal()} >
            <View style={{width:app_size.width, backgroundColor: Colors.shades.white, borderTopRightRadius: 42, borderTopLeftRadius: 42, paddingBottom:35, paddingTop:10}}>
                <ScrollView style={{padding:32}}>
                    <Text color={Colors.brand.midnight} weight='bold' size={16}>Schedule</Text>
                    <View style={{paddingBottom:19, borderBottomWidth:1, borderColor:Colors.shades.shade400}}>
                        <FlatList data={scheduleOptions} renderItem={renderScheduleOptions} keyExtractor={(item) => item.type} />
                    </View>
                    {company_tags.length > 0 ?
                        <View style={{marginTop:19}}>
                            <Text color={Colors.brand.midnight} weight='bold' size={16}>Post For My Company</Text>
                            <View style={{ flexDirection:'row' }}>
                                <FlatList data={company_tags} renderItem={renderCompanyTopics} keyExtractor={(item) => item.player_tag_id.toString()} />
                                <PlayerTagLozenge selected={featured} player_tag={{ 
                                tag_id:'featured',
                                player_tag_id: 'featured',
                                tag_type: 'selected',
                                create_datetime: '',
                                last_update_datetime: '',
                                status: 'active',
                                tag: 'Feature My Post',
                                }} onSelect={(tag) => setFeatured(!featured)}/>
                            </View>
                        </View>
                    :<></>}
                    <View style={{marginTop:19}}>
                        <View style={{flexDirection:'row', alignItems:'center'}}>
                            <Text style={Styles.textStyles.blueBoldLeft16}>Memo Topics</Text>
                            {selectedTopics.length > 0 ?
                            <View style={{marginLeft:4, borderRadius:100, justifyContent:'center', alignItems:'center', height:20, width:20, backgroundColor:Colors.highlights.highlight200}}>
                                <Text size={10} color={Colors.shades.white}>{selectedTopics.length}</Text>
                            </View>
                            :<></>}
                        </View>
                        <View style={{ flexDirection:'row', alignItems:'center', marginTop:12, backgroundColor:Colors.shades.shade100, borderRadius:4 }}>
                            <TextInput style={{flex:7/8, padding:13, fontSize:16, color:Colors.shades.black}} placeholder='Search...' onChangeText={(e) => setSearchValue(e)}/>
                            <Icon containerStyle={{flex:1/8}} name='search' type='feather' color={Colors.accents.accent100} size={16}/>
                        </View>
                        <View style={{flexDirection:'row', flexWrap:'wrap'}}>
                            {selectedTopics.map(t => {
                                return renderSelectedTopics(t)
                            })}
                        </View>
                        <View style={{flexDirection:'row', flexWrap:'wrap'}}>
                            {availTopics.map(t => {
                                return renderAvailableTopics(t)
                            })}
                        </View>
                        {loading?
                        <View style={{padding:20, justifyContent:'center', alignItems:'center'}}>
                            <ActivityIndicator size='large' color={Colors.highlights.highlight200} />
                        </View>
                        :<></>}
                    </View>
                </ScrollView>
                <View style={Styles.viewStyles.modalCloseContainer}>
                    <View style={{flex:1,flexDirection:'row', alignItems:'center'}}>
                        <TouchableOpacity style={{flex:1/3, padding:5, margin:16, marginRight:8, borderRadius:4, borderWidth:1, borderColor:Colors.brand.midnight }} onPress={() => closeModal()}>
                            <Text textAlign='center' size={14} color={Colors.brand.midnight} weight='bold' style={{padding:5}}>Cancel</Text>
                        </TouchableOpacity>
                        <TouchableOpacity style={{ flex:2/3,margin:16, padding:5, marginLeft:8, borderWidth:1, borderColor:Colors.utility.success, backgroundColor:Colors.utility.success }} onPress={() => onAdd(selectedTopics, featured)}>
                            <Text textAlign='center' size={14} color={Colors.shades.white} weight='bold' style={{padding:5}}>Publish</Text>
                        </TouchableOpacity>
                    </View>
                </View>
            </View>
        </Modal>
    )

}

const areEqual = (prevProps:PublishPostModalProps, nextProps:PublishPostModalProps) => {
    if(prevProps.isVisible !== nextProps.isVisible){ return false }
    return true
}

export default React.memo(PublishPostModal, areEqual)